import HighchartsReact from "highcharts-react-official";
import ScoringLoading from "../utils/ScoringLoading";

export default function BaseScoringChart({ isLoading = false, highcharts: Highcharts, options, ...props }) {
  return isLoading ? <ScoringLoading /> : <HighchartsReact highcharts={Highcharts} options={options} {...props} />;
}
